// ABOUTME: Reusable loading spinner component using MUI CircularProgress
// ABOUTME: Provides consistent loading states across the application

import { Box, CircularProgress } from "@mui/material";
import React from "react";

interface LoadingSpinnerProps {
  minHeight?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  minHeight = "200px",
  size = 40,
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={minHeight}
  >
    <CircularProgress size={size} />
  </Box>
);

export default LoadingSpinner;
